












import Vue from "vue";
import Component from "vue-class-component";
import { Provide } from "vue-property-decorator";
import { Prop } from "vue-property-decorator";
import { ICellRendererParams } from "ag-grid-community";
import { IClonePromotionModel } from "../../models";

@Component
export default class ClonePromotionButton extends Vue {
    @Provide("params")
    params!: ICellRendererParams;

    @Prop({ required: false })
    id!: number | null;

    @Prop({ required: false, default: "sm" })
    size!: string | null;

    get model(): IClonePromotionModel {
        if (this.params && this.params.data) {
            return this.params.data as IClonePromotionModel;
        }

        const model = { id: this.id } as IClonePromotionModel;
        return model;
    }

    modalOpen = false;

    cloneClicked() {
        this.modalOpen = true;
    }
}
